import React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import {render} from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import theme, { Fonts } from "./theme";
import { AudioPlayerProvider } from "react-use-audio-player";
import { SettingsProvider } from "./contexts/SettingsContext";
import firebaseInstance from "./firebaseConfig";
import polyfill from "./polyfillScript";

const initialInteractiveExercise = async () => {
  // We initialize polyfill and main.js from the shared library domain 
  firebaseInstance.initializeEnvironment();
  polyfill.initializePolyfill(process.env.REACT_APP_SHAREDLIB_DOMAIN);

  render(
    <React.StrictMode>
      <BrowserRouter basename={`${process.env.PUBLIC_URL}`}>
        <SettingsProvider>
          <ChakraProvider theme={theme}>
            <Fonts />
            <App />
          </ChakraProvider>
        </SettingsProvider>
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("root")
  );
};

declare global {
  interface Window {
    ExerciseInteractive: {
        initialInteractiveExercise: () => void;
      }
  }
}

Object.assign(window, {
  ExerciseInteractive: {
    initialInteractiveExercise
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
